import * as React from "react";
const SvgFiRrBranding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-branding_svg__a)">
      <path
        fill="#062147"
        d="M3 0C1.346 0 0 1.346 0 3v9.343c0 1.336.521 2.592 1.465 3.536l.828.828a.997.997 0 0 0 1.414 0l.828-.828A4.97 4.97 0 0 0 6 12.343V3c0-1.654-1.346-3-3-3m1 12.343c0 .802-.313 1.556-.879 2.122L3 14.586l-.121-.121A2.98 2.98 0 0 1 2 12.343V3a1 1 0 0 1 2 0zm18.535-9.222-1.656-1.656A4.97 4.97 0 0 0 17.343 0H12C9.794 0 8 1.794 8 4v6a1 1 0 1 0 2 0V4c0-1.103.897-2 2-2h5v3c0 1.103.897 2 2 2h3v12a1 1 0 1 0 2 0V6.657a4.97 4.97 0 0 0-1.465-3.536M19 2.499q.248.165.465.38l1.656 1.656q.216.216.38.465H19zM17 13h-7c-1.654 0-3 1.346-3 3v5c0 1.654 1.346 3 3 3h7c1.654 0 3-1.346 3-3v-5c0-1.654-1.346-3-3-3m0 2c.025 0 .047.013.071.014l-2.606 2.606a1.367 1.367 0 0 1-1.932 0l-2.606-2.606c.025-.002.046-.014.071-.014H17m0 7h-7a1 1 0 0 1-1-1v-4.086l2.12 2.12c.636.636 1.48.986 2.38.986s1.744-.351 2.38-.986l2.12-2.12V21a1 1 0 0 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-branding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBranding;
